/* eslint-disable import/prefer-default-export */
import { useLayoutEffect, useEffect } from 'react'

export const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect
